// extracted by mini-css-extract-plugin
export default {"Maschine":"Maschine_Maschine__rXFok","fadeIn":"Maschine_fadeIn__UY4cX"};